const colorsHex = {
  midnight: '#002E45', // Acenda/Midnight/500
  midnight400: '#003F5E', // Acenda/Midnight/400
  gold: '#FFBB00', // Acenda/New Gold
  yellowAcenda: '#F7CC68', // Acenda/Aqua/50

  vibrantBlue100: '#0095FF', // Vibrant Blue
  vibrantBlue200: '#0070BF', // Vibrant Blue/Dark
  vibrantBlue300: '#004A80', // Vibrant Blue/Darker

  aquaDark: '#6DE9F2', // Acenda/Aqua/100
  aquaDefault: '#00BECC', // Acenda/Aqua/200
  aquaLight: '#009BA6', // Acenda/Aqua/300

  sand100: '#F2F0ED', // Sand
  sand200: '#E6E4E1', // Sand/Dark
  sand300: '#D9D7D4', // Sand/Darker

  white: '#FFF', // White
  grey100: '#8A8A8A', // Grey/Light
  // ---------
  aquaDefault60: '#67B5BA', //Tints/Aqua/Default/60
  aquaDefault40: '#99CDD1', //Tints/Aqua/Default/40
  aquaDefault20: '#CCE6E8', //Tints/Aqua/Default/20
  aquaDefault5: '#E6EDEE', //Tints/Aqua/Default/5
  warmGrey200: '#E8E6E2',
  warmGrey100: '#F0EEEA',
  neutralGrey: '#BDBDBD',

  black: '#000',
  red: '#E40571',
};

export default colorsHex;
